import { ComponentStyleConfig } from '@chakra-ui/react'

export const Link: ComponentStyleConfig = {
    baseStyle: { cursor: 'pointer', textDecoration: 'none !important' },
}
